module.exports = __webpack_public_path__ + "img/shopping-basket.d4f02827.svg";